export default "__VITE_ASSET__JlelSJ19__"